module.exports = __webpack_public_path__ + "images/hub-back-to-pattern.svg";